import {Injectable} from '@angular/core';
import {HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {LoadIndicatorService} from '../components/loadindicator/loadindicator.service';

@Injectable()
export class LoadIndicatorInterceptor implements HttpInterceptor {

  constructor(private loadIndicatorService: LoadIndicatorService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // If we flag that we don't want a loader for this call, bail out
    if (req.context.get(HTTP_LOADER) === false) {
      return next.handle(req);
    }

    const key = req.urlWithParams;

    this.loadIndicatorService.push(key);

    return next
      .handle(req)
      .pipe(
        tap({
          next: resp => {
            if (resp instanceof HttpResponse) {
              this.loadIndicatorService.pop(key);
            }
          },
          error: () => {
            this.loadIndicatorService.pop(key);
          },
        }),
      );
  }
}

// Flag to show/hide the load indicator during the HTTP call
export const HTTP_LOADER = new HttpContextToken<boolean>(() => true);
